<template>
  <section class="home">
    <div class="home-menu">
      <h1><span>Atelier&nbsp;</span>Adão Paranhos </h1> 
      <h1 class="slideIn"> 
        <span class="indicador">&nbsp;</span> 
        <router-link to="/portfolio">Portfolio</router-link>
        <span class="separador">&nbsp;</span> 
        <router-link to="/atelier">Atelier</router-link>
        <span class="separador">&nbsp;</span> 
        <router-link to="/registos">Registos</router-link>
        <span class="separador">&nbsp;</span> 
        <router-link to="/contactos">Contactos</router-link>
      </h1>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Home',
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">




$red: #FF0000;
$blue: #00AA9A;



.home {
  background: black;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%; 
  display: flex;
  justify-content: center;
  align-items: center;
  
  &-menu {
    display: flex;
    flex-wrap: wrap;
    font-family: 'Ropa Sans', sans-serif;

    h1 {
    color: white;
    font-size: 24px;
    text-transform: lowercase;
      a {
        color: #5f5f5f;
        &:hover {
          text-decoration: none;
          color: white;
        }
      }
      span {
        color: #ff6200;
        &.separador{
          color: white;
          font-size: 15px;
        }
      }
      &.slideIn {
        height: 25px;
        width: 0px;
        opacity: 0;
        display: block;
        overflow: hidden;      
        animation: slideIn 2s forwards ;
        animation-delay: 2s;
        .indicador {
          color: white;
          font-size: 15px;
          margin: 0 3px;
        }
      }
    }
  }
}

@keyframes slideIn {
  0%   { 
    width: 0; 
  }
  50% { 
    width: 585px;
    opacity: 0;
  }
  100% {
    width: 585px;
    opacity: 1;
  }
}
@keyframes slideInResponsive {
  0%   { 
  }
  50% { 
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}


@media (max-width: 768px) {
.home {
  &-menu {
    padding: 8vw;
    height: 100%;
    display: block;
    h1 {
      font-family: 'Zantroke', Georgia, serif;
      font-size: 11vw;
      line-height: 1.1;
      margin: 0;
      color: white;
      animation: slideInResponsiveatelier 2s forwards ;

      span {
        color: white;
        display: block;
      }
      a {
        list-style: 1.1;
        color: white;
      }
      &.slideIn {
        height: auto;
        animation: slideInResponsive 2s forwards ;
        animation-delay: 2s;
        width: auto;
        background: black;
        position: absolute;
        top: 8vw;
        left: 8vw;
        .indicador, .separador {
          display: none;
        }
      }      
    }
  }
}
}



</style>
